module.exports = __webpack_public_path__ + "media/images/icons/meditation-5c1f0ab722aed785c301f905cfe83cbc.png";